import { useState } from 'react';

import { cn, initials } from '@/lib/utils';

export type AvatarSize = 'sm' | 'md' | 'lg';

const SIZES: Record<AvatarSize, string> = {
  sm: 'size-8 text-xs',
  md: 'size-10 text-sm',
  lg: 'size-14 text-base',
};

interface AvatarProps {
  name: string;
  src?: string | null;
  size?: AvatarSize;
  className?: string;
}

/**
 * Avatar con foto opcional.
 * Si no hay imagen (o falla al cargar) muestra las iniciales del usuario.
 */
export function Avatar({ name, src, size = 'md', className }: AvatarProps) {
  const [failed, setFailed] = useState(false);
  const hasPhoto = Boolean(src && src.trim() !== '') && !failed;

  const base = cn(
    'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full',
    'bg-gradient-to-br from-brand-500 to-accent-600 font-semibold text-white ring-2 ring-white',
    SIZES[size],
    className,
  );

  if (hasPhoto) {
    return (
      <img
        src={src ?? undefined}
        alt={name}
        loading="lazy"
        className={cn(base, 'object-cover')}
        onError={() => setFailed(true)}
      />
    );
  }

  return (
    <span className={base} aria-hidden="true">
      {initials(name)}
    </span>
  );
}
